/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

// itemExtents[i] is the end position of item i (offsetLeft + offsetWidth)
// relative to the start of the first item in the list.
export const getVisibleItemCount = (containerWidth: number, itemExtents: number[]) => {
  let count = 0;
  for (const extent of itemExtents) {
    if (extent > containerWidth) {
      break;
    }
    count += 1;
  }
  return Math.max(count, 1);
};
